import { memo } from 'react'
import { createUseStyles } from 'react-jss'
import { removeParagraph } from '@/utils/strings'
import style from './style'

const useStyles = createUseStyles(style)

const Profile = ({
  title,
  text,
  items,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {title && (
        <h2
          className={classes.title}
          dangerouslySetInnerHTML={{ __html: removeParagraph(title) }}
        />
      )}
      {text && (
        <div
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
      <div className={classes.list}>
        {items.map((item, i) => (
          <div
            className={classes.item}
            key={i.toString()}
          >
            <h3>{item.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: item.text }} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default memo(Profile)
